import { VpSkeleton } from '@vtmn-play/react'
import { VpDivider } from '@vtmn-play/react/VpDivider'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'

const VendorDetailSkeleton = () => {
  return (
    <div className="h-full overflow-auto flex flex-col">
      <div className="p-5 flex flex-col items-start gap-5">
        <VpSkeleton className="h-6 w-20" variantStyle="on-brand" />
        <VendorDetailSummarySkeleton />
      </div>
      <div className="flex-1 bg-white rounded-t-2xl p-5 flex flex-col gap-3">
        <VpSkeleton className="h-12" shape="squared" />
        <FamilyCardListSkeleton skeletonCount={4} skeletonHeight={98} />
      </div>
    </div>
  )
}

const VendorDetailSummarySkeleton = () => {
  return (
    <div className="w-full flex gap-3">
      <div className="flex-1 flex items-center gap-3">
        <VpSkeleton
          className="h-10 w-10 p-2 rounded-full"
          shape="rounded"
          variantStyle="on-brand"
        />
        <div className="flex-1 flex flex-col gap-1">
          <VpSkeleton className="h-6 w-35" variantStyle="on-brand" />
          <VpSkeleton className="h-4 w-35" variantStyle="on-brand" />
        </div>
      </div>
      <VpDivider orientation="vertical" />
      <div className="flex flex-col items-center gap-1">
        <VpSkeleton className="h-7 w-22" variantStyle="on-brand" />
        <VpSkeleton className="h-6 w-22" variantStyle="on-brand" />
      </div>
    </div>
  )
}

export default VendorDetailSkeleton
